export const defer = (callback, timeout) => {
    const timeoutFunction = window.setTimeout(callback, timeout);
    return () => window.clearTimeout(timeoutFunction);
};
